import './ToolTip.scss';

type PositionTypes = 'right' | 'left';

interface ToolTipProps {
  content: React.ReactNode;
  children?: React.ReactNode;
  position?: PositionTypes;
}

const ToolTip = ({ content, children, position = 'right' }: ToolTipProps) => {
  const className = 'c-ToolTip';

  return (
    <div className={className}>
      <span className={`${className}__container`}>{children}</span>
      <div
        className={`${className}__popup ${
          position !== 'right' ? `${className}__popup--${position}` : ''
        }`}
      >
        <div className={`${className}__popup--inner`}>{content}</div>
      </div>
    </div>
  );
};

export default ToolTip;
